import React from "react";
import { InputText } from "@loanbossinc/component-library";
import { Search } from "@material-ui/icons";
import styled from "styled-components/macro";

const FilterWrapper = styled.div`
  text-align: end;
`;

const StyledInputText = styled(InputText)`&& {
  min-width: 500px;
  width: 100%;
  && > div {
    font-family: Work Sans;
    margin-left: ${({ marginLeft }) => marginLeft ?? "2em"};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    background-color: #FFFFFF;
    border-radius: 8px;
    width: ${({ width }) => width ?? "100%"};
  }
  && > div > svg {
    margin-right: 0.5em;
  }
}`;

const SearchBar = ({ searchText, setSearchText = () => { }, placeholder, marginLeft, width }) => (
  <FilterWrapper>
    <StyledInputText
      type="search"
      variant="outlined"
      borderRadius={8}
      marginLeft={marginLeft}
      width={width}
      placeholder={placeholder}
      onChange={e => setSearchText(e.target.value)}
      value={searchText}
      InputProps={{ startAdornment: <Search /> }}
    />
  </FilterWrapper>
);

export default SearchBar;
